import { useLocalObservable } from 'mobx-react-lite';
import { runInAction } from 'mobx';
import type { CameraHistory } from '@/models/camera/types';
import { fetchCameraHistory } from '@/models/camera/service';

export function useHistoryModal() {
  const store = useLocalObservable(() => ({
    isOpen: false,
    idCamera: '',
    cameraName: '',
    history: [] as CameraHistory[],
    isLoading: false,
    error: null as string | null,
  }));

  function open(idCamera: string, cameraName: string) {
    runInAction(() => {
      store.isOpen = true;
      store.idCamera = idCamera;
      store.cameraName = cameraName;
      store.history = [];
      store.isLoading = true;
      store.error = null;
    });
    fetchCameraHistory(idCamera)
      .then((history) =>
        runInAction(() => {
          store.history = history;
          store.isLoading = false;
        })
      )
      .catch((err: Error) =>
        runInAction(() => {
          store.error = err.message;
          store.isLoading = false;
        })
      );
  }

  function close() {
    runInAction(() => {
      store.isOpen = false;
    });
  }

  return {
    get isOpen() {
      return store.isOpen;
    },
    get idCamera() {
      return store.idCamera;
    },
    get cameraName() {
      return store.cameraName;
    },
    get history() {
      return store.history;
    },
    get isLoading() {
      return store.isLoading;
    },
    get error() {
      return store.error;
    },
    open,
    close,
  };
}

export type HistoryModal = ReturnType<typeof useHistoryModal>;
